import setup from './moduleSetup';

export default {
    name: 'queue',
    before: [],
    after: [],
    setup,
};
